var _path, _path2, _path3, _path4, _circle, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.63782 26.8163C2.68174 26.8163 0.888672 28.2749 0.888672 30.0576V23.5313C0.888672 21.7486 2.68174 20.29 4.63782 20.29C6.7569 20.29 8.38696 21.7486 8.38696 23.5313C8.38696 21.7486 10.18 20.29 12.1361 20.29C14.2552 20.29 15.8853 21.7486 15.8853 23.5313C15.8853 21.7486 17.5153 20.29 19.6344 20.29C22.0795 20.29 23.7096 21.7486 23.7096 23.5313V30.0576C23.7096 28.2749 22.0795 26.8163 19.6344 26.8163C17.5153 26.8163 15.8853 28.2749 15.8853 30.0576C15.8853 28.2749 14.2552 26.8163 12.1361 26.8163C10.18 26.8163 8.38696 28.2749 8.38696 30.0576C8.38696 28.2749 6.7569 26.8163 4.63782 26.8163Z",
    fill: "#6BE3A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7096 30.0597V4.12989C23.7096 2.34722 22.2425 0.888672 20.4494 0.888672H4.1488C2.35573 0.888672 0.888672 2.34722 0.888672 4.12989V30.0597C0.888672 28.277 2.68174 26.8184 4.63782 26.8184C6.7569 26.8184 8.38696 28.277 8.38696 30.0597C8.38696 28.277 10.18 26.8184 12.1361 26.8184C14.2552 26.8184 15.8853 28.277 15.8853 30.0597C15.8853 28.277 17.5153 26.8184 19.6344 26.8184C22.0795 26.8184 23.7096 28.277 23.7096 30.0597Z",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41016 13.8525H17.1905",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41016 7.37109H17.1905",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5545,
    cy: 23.5554,
    r: 6.61111,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0336 17.4249C25.268 17.115 24.4312 16.9443 23.5545 16.9443C19.9033 16.9443 16.9434 19.9042 16.9434 23.5554C16.9434 27.2067 19.9033 30.1666 23.5545 30.1666C27.2057 30.1666 30.1656 27.2067 30.1656 23.5554C30.1656 23.2756 30.1482 22.9998 30.1144 22.7291",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9336 21.6908L24.1717 24.6701L30.1853 18.2314",
    stroke: "#383434",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaid);
export default __webpack_public_path__ + "static/media/paid.88c1db916f475248e7ea39502aab438e.svg";
export { ForwardRef as ReactComponent };